<template>
  <div class="full" style="min-height: 100%;padding: 1rem">
    <Card :bordered="false" class="approvalContainer mb1" dis-hover>
      <p slot="title">
        <Icon type="md-mail" />
        &nbsp;{{inboxForm.typeLabel}}消息
      </p>
      <Button
        @click.prevent="reply"
        slot="extra"
        type="text"
        v-if="inboxForm.msgFrom != '' && !(inboxForm.currentReply && isReply) "
      >
        <Icon type="md-paper-plane" />回复
      </Button>
      <ul class="inboxContainer">
        <li>
          <div style="flex: 1;    display: flex;">
            <div class="itemLabel">发件人</div>
            <div class="itemValue">{{getUserName(inboxForm.msgFrom)}}</div>
          </div>
          <div style="flex: 1;    display: flex;">
            <div class="itemLabel">收件人</div>
            <div class="itemValue">{{getUserName(inboxForm.msgTo)}}</div>
          </div>
        </li>
        <li></li>
        <li v-if="inboxForm.msgCC && inboxForm.msgCC.length > 0">
          <div class="itemLabel">抄送</div>
          <div class="itemValue">{{getUsersName(inboxForm.msgCC)}}</div>
        </li>
        <li>
          <div class="itemLabel">主题</div>
          <div class="itemValue">{{inboxForm.title}}</div>
        </li>
        <li v-if="inboxForm.otherData && inboxForm.otherData.enclosure">
          <div class="itemLabel">附件</div>
          <div class="itemValue">
            <div
              :key="index + '-f'"
              v-for="(item, index) in Object.values(inboxForm.otherData.enclosure)"
            >
              <a
                :href="this.$store.getters['systemSupport/systemSupport']?.file + item.baseUrl"
              >{{item.name}}</a>
            </div>
          </div>
        </li>
        <li>
          <div class="itemLabel">内容</div>
          <div class="itemValue">{{inboxForm.content}}</div>
        </li>
      </ul>
      <Divider />
      <div class="otherInfo">
        <div class="mr1">
          已读
          <strong>{{inboxForm.readUser?inboxForm.readUser.length: 0}}</strong>人
        </div>
        <Divider type="vertical" />
        <div>
          已回复
          <strong>{{inboxForm.replyUser?inboxForm.replyUser.length: 0}}</strong>人
        </div>
      </div>
    </Card>
    <Card :bordered="false" class="approvalContainer mb1" dis-hover v-if="inboxForm.currentReply">
      <p slot="title">
        <Icon type="md-paper-plane" />&nbsp;我的回复
      </p>
      <ul class="inboxContainer">
        <li>
          <div style="flex: 1;    display: flex;">
            <div class="itemLabel">发件人</div>
            <div class="itemValue">{{getUserName(inboxForm.currentReply.msgFrom)}}</div>
          </div>
          <div style="flex: 1;    display: flex;">
            <div class="itemLabel">收件人</div>
            <div class="itemValue">{{getUserName(inboxForm.currentReply.msgTo)}}</div>
          </div>
        </li>
        <li></li>
        <li v-if="inboxForm.currentReply.msgCC && inboxForm.currentReply.msgCC.length > 0">
          <div class="itemLabel">抄送</div>
          <div class="itemValue">{{getUsersName(inboxForm.currentReply.msgCC)}}</div>
        </li>
        <li>
          <div class="itemLabel">主题</div>
          <div class="itemValue">{{inboxForm.currentReply.title}}</div>
        </li>
        <li v-if="inboxForm.currentReply.files && inboxForm.currentReply.files.length > 0">
          <div class="itemLabel">附件</div>
          <div class="itemValue">
            <div :key="index + '-f'" v-for="(item, index) in inboxForm.currentReply.files">
              <a :href="item.url">{{item.name}}</a>
            </div>
          </div>
        </li>
        <li>
          <div class="itemLabel">内容</div>
          <div class="itemValue">{{inboxForm.currentReply.content}}</div>
        </li>
      </ul>
      <Divider />
      <div class="otherInfo">
        <div class="mr1">
          已读
          <strong>{{inboxForm.currentReply.readUser?inboxForm.currentReply.readUser.length: 0}}</strong>人
        </div>
        <Divider type="vertical" />
        <div>
          已回复
          <strong>{{inboxForm.currentReply.replyUser?inboxForm.currentReply.replyUser.length: 0}}</strong>人
        </div>
      </div>
    </Card>

    <Card :bordered="false" class="approvalContainer mb1" dis-hover v-if="isReply">
      <p slot="title">回复</p>
      <Form :label-width="100" :model="replyForm" :rules="replyFormValidate" ref="replyForm">
        <FormItem label="抄送人" prop="msgCC">
          <Select :max-tag-count="3" multiple placeholder="请选择抄送账号" v-model="replyForm.msgCC">
            <Option
              :disabled="item.value == replyForm.msgFrom || item.value == replyForm.msgTo"
              :key="item.value+'-ccToOpt'"
              :value="item.value"
              v-for="item in userOptions"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="主题" prop="title">
          <Input autocomplete="off" placeholder="请输入主题" type="text" v-model.trim="replyForm.title"></Input>
        </FormItem>
        <FormItem label="附件" prop="otherData">
          <sunflowerFileUpload :opts="fileOpts" @uploadFile="uploadFile" v-if="isReply"></sunflowerFileUpload>
        </FormItem>
        <FormItem label="内容" prop="content">
          <Input
            :autosize="{minRows: 5,maxRows: 10}"
            autocomplete="off"
            maxlength="1000"
            placeholder="请输入站内信内容"
            show-word-limit
            type="textarea"
            v-model.trim="replyForm.content"
          />
        </FormItem>
      </Form>
      <Divider />
      <div class="textC">
        <Button @click="cancelReply" class="mr1" ghost type="primary">取消</Button>
        <Button @click="replyMessage" type="primary">回复</Button>
      </div>
    </Card>
  </div>
</template>
<script>
export default {
  props: {
    id: Number
  },
  data () {
    return {
      isReply: false,
      userOptions: [],
      inboxForm: {},
      replyFormValidate: {
        msgFrom: [{ required: true, message: '发件人不能为空', trigger: "change" }],
        msgTo: [{ required: true, message: '收件人不能为空', trigger: "change" }],
        msgTo: [{ required: true, message: '收件人不能为空', trigger: "change" }],
        title: [{ required: true, message: '主题不能为空', trigger: "blur" }],
        content: [{ required: true, message: '内容不能为空', trigger: "blur" }],
      },
      account: this.$store.getters['userInfo/account'],
      fileOpts: {
        multiple: true,
        showUploadList: true,
        defauleFiles: [],
        type: 'select',
        data: {
          catalogName: "inboxReply"
        },
      },
      replyForm: {
        id: null,
        parentId: null,
        msgFrom: this.account,
        msgTo: '',
        msgCC: [],
        title: '',
        content: '',
        otherData: {},
        fileIds: []
      },
    }
  },
  methods: {
    uploadFile: function (data) {
      let enclosure = {}
      let fileIds = []
      data.forEach(file => {
        console.log(file)
        fileIds.push(file.fileId)
        enclosure[file.fileId] = {
          baseUrl: file.baseUrl,
          name: file.name
        }
      })
      this.replyForm.otherData.enclosure = enclosure
      this.replyForm.fileIds = fileIds
    },
    reply: function () {
      this.isReply = true
      if (this.$refs.replyForm) this.$refs.replyForm.resetFields()
      this.replyForm = {
        id: null,
        parentId: this.inboxForm.id,
        msgFrom: this.account,
        msgTo: this.inboxForm.msgFrom,
        title: '',
        content: '',
        otherData: {}
      }
    },
    cancelReply: function () {
      if (this.$refs.replyForm) this.$refs.replyForm.resetFields()
      this.replyForm = {
        id: null,
        parentId: this.inboxForm.id,
        msgFrom: this.account,
        msgTo: this.inboxForm.msgFrom,
        title: '',
        content: '',
        otherData: {}
      }
      this.isReply = false
    },
    replyMessage: function () {
      let that = this
      this.$refs["replyForm"].validate(valid => {
        if (valid) {
          that.$axios.post(that.$apis.inboxApi.replyMessage, that.replyForm).then(res => {
            if (res.success) {
              that.$Message.success("回复成功！")
              this.$emit('close')
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error("回复失败！")
          })
        } else {
          return false
        }
      })
    },
    getUserName: function (data) {
      for (const user of this.userOptions) {
        if (user.value == data) return user.label
      }
      return data
    },
    getUsersName: function (users) {
      let names = []
      users.forEach(ele => {
        names.push(this.getUserName(ele))
      })
      return names.join("、")
    },
    getUsers: function () {
      let _this = this
      this.userOptions = []
      _this.$axios.post(_this.$apis.systemManager.userManager.getUserOptions).then(res => {
        if (res.status === _this.$common.resCode.SUCCESS) {
          _this.userOptions = res.result || []
        } else {
          _this.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log("err", err)
        _this.$Message.error('获取帐号失败！')
      })
    },
    loadInboxInfo: function () {
      let that = this
      let params = new this.$URLSearchParams()
      params.append('id', this.id)
      this.$axios.post(that.$apis.inboxApi.getDetail, params).then(res => {
        if (res.success) {
          that.inboxForm = res.result || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取站内信失败！")
      }).then(val => {
        that.initInboxCount()
      })
    },
    initInboxCount: function () {
      let that = this
      this.$axios.post(that.$apis.inboxApi.getCount).then(res => {
        if (res.success) {
          let data = res.result || {}
          this.$store.commit("SET_INBOXCOUNT", data.count || 0)
          this.$store.commit("SET_INBOXLIST", data.inboxList || [])
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取站内信失败！")
      })
    },
  },
  beforeMount () {
    this.getUsers()
    this.loadInboxInfo()
  }
}
</script>
<style scoped>
.inboxContainer {
  list-style: none;
  margin: 1rem;
}

.inboxContainer li {
  display: flex;
  line-height: 2rem;
}

.inboxContainer .itemLabel {
  font-size: 0.8rem;
  color: #888;
  width: 100px;
  padding: 0 1rem;
}

.inboxContainer .itemValue {
  font-size: 0.85rem;
  color: #666;
  flex-grow: 1;
}

.otherInfo {
  color: #999;
  font-size: 0.7rem;
  display: flex;
  align-items: baseline;
  justify-content: space-around;
}
</style>